/* eslint-disable require-jsdoc */
import React, { useEffect, useState } from 'react';
import Searchbox from './Searchbox';
import Locations from './Locations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Filters from './Filters/Filters';
import { debug, geoApiKey, isHearby } from '../config';
import http from '../services/http';
import { A4map } from '../hearbymap/src/A4map/A4map';
import _ from 'lodash';
export default function Searchbar(props) {
  const [lat, setLat] = useState(props.settings.defaultLocation.lat);
  const [lon, setLon] = useState(props.settings.defaultLocation.lon);
  const [loc, setLoc] = useState({lat: props.settings.defaultLocation.lat, lon: props.settings.defaultLocation.lon});

  const [minDate, setMinDate] = useState('2021-03-13');
  const [maxDate, setMaxDate] = useState('2021-09-13');
  const [searchVal, setSearchVal] = useState('');
  const [geolocation, setGeolocation] = useState(props.settings.defaultLocationName);
  const [loadingGeolocation, setLoadingGeolocation] = useState(true);
  const [locPopoverOpen, setLocPopoverOpen] = useState(false);
  const [calendarPopover, setCalendarPopOver] = useState(false);
  const [genrePopoverOpen, setGenrePopoverOpen] = useState(false);
  // flag listen
  useEffect(() => {
            const geocodeEarth = geoApiKey;
            const query = `https://api.geocode.earth/v1/reverse?api_key=${geocodeEarth}&point.lat=${loc.lat}&point.lon=${loc.lon}`;
            getResults(query);
        // setLoadingGeolocation(false);
      // getResults(query);
    console.log('loc changed! 21', loc);
  }, [loc]);

  const [submit, setSubmit] = useState(false);
  const [searchSubmit, setSearchSubmit] = useState(false);

  // event search
  const [evtsubmit, setEvtSubmit] = useState(false);
  const [eventsubmit, setEventSubmit] = useState(false);
  const [eventsearchsubmit, setEventSearchSubmit] = useState(false);

  const [searchEraseAndSubmit, setSearchEraseAndSubmit] = useState(false);

  window.changeSearchBarLoc = function (newLat, newLon) {
      const newLoc = {
        lat: newLat,
        lon: newLon
      }
      if (!_.isEqual(loc, newLoc)) {
        setLoc(newLoc);
        console.log('set new loc', loc);
      }
    //  _.isEqual(loc, newLoc) ? null : setLoc(newLoc);
    };

  const handleClick = () => {
    setSubmit(true);
    //window.aMap.changeLocation(lat, lon);
    
    // if (!locChanged(this.loc.lat, this.loc.lng, lat, lng)) {
    //   //A4map.get.setMapMarkers();
    // }
    if(props.settings.components.carousel === true){
      window.changePowersearchLoc(loc.lat, loc.lon);     
    }
    setTimeout(
      function () {
        setSubmit(false)
      },
      3000);
  }
  const options = {
    enableHighAccuracy: true,
    timeout: 300,
    maximumAge: 0
  };

  // useEffect(() => {

  //   if (window.powersearchUserSettings.geolocation) {
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(
  //         function (position) {
  //           const geocodeEarth = geoApiKey;
  //           const query = `https://api.geocode.earth/v1/reverse?api_key=${geocodeEarth}&point.lat=${position.coords.latitude}&point.lon=${position.coords.longitude}`;
  //           getResults(query);
  //         },

  //         function (error) {
  //           debug && console.log('geolocation error', error);
  //         });
  //       // setLoadingGeolocation(false);
  //     }
  //     // getResults(query);
  //   }
  // }, []);

  const sanitize = (data) => {
    return (data !== '' && data !== undefined) ? (data + ', ') : '';
  }
  const sanitizeCountry = (data) => {
    return (data !== '' && data !== undefined) ? (data) : '';
  }

  const getResults = async (queryStr) => {
    try {
      const response = await http.get(queryStr, false);
      debug && console.log('results fetched ', response);
      setGeolocation(sanitize(response['features'][0]['properties']['locality']) +
        sanitize(response['features'][0]['properties']['region_a']) +
        sanitizeCountry(response['features'][0]['properties']['country_a']));
      debug && console.log(loadingGeolocation);
      const newLat = response['features'][0]['geometry']['coordinates'][1];
      const newLon = response['features'][0]['geometry']['coordinates'][0];
    //  setLat(newLat);
     // setLon(newLon);
      // debug && console.log("set new loc");
      // window.aMap.changeLocation(newLat, newLon);
      // //window.aMap.init();
      // // window.aMap.loc.lat = lat;
      // // window.aMap.loc.lng = lon;
      // debug && console.log('coords', newLat, newLon);

      // setTimeout(function(){
      //   if(props.settings.components.carousel === true){
      //     window.changePowersearchLoc(newLat, newLon);
      //   }
      //   if(props.settings.components.map === true){
      //     A4map.get.setInitialLocation(newLat, newLon);
      //   }
      //   }, 500);
     

      //successMapChange({lat: lat, lon: lon}, window.aMapRef);
      //  setLoadingGeolocation(false);
    } catch (err) {
      // setLoadingGeolocation(true);
      console.error(err.message);
    }
  };

  if(!props.settings.components.searchBar){
    return (null);
  } else {
    return (
      <div className="hearby-searchbar">
        <Searchbox searchVal={searchVal} setEventSearchSubmit={setEventSearchSubmit} 
          setSearchVal={setSearchVal} setEventSubmit={setEventSubmit}/>
        <Locations minDate={minDate} maxDate={maxDate} loc={loc} setLoc={setLoc} 
          geolocation={geolocation} setGeolocation={setGeolocation} 
          locPopoverOpen={locPopoverOpen} setLocPopoverOpen={setLocPopoverOpen} setCalendarPopOver={setCalendarPopOver} setGenrePopoverOpen={setGenrePopoverOpen} />
        <Filters searchVal={searchVal} eventsearchsubmit={eventsearchsubmit} eventsubmit={eventsubmit} setEventSubmit={setEventSubmit} submit={submit} setSubmit={setSubmit} setEventSearchSubmit={setEventSearchSubmit} loc={loc} setLoc={setLoc} 
          calendarPopover={calendarPopover} genrePopoverOpen={genrePopoverOpen} setCalendarPopOver={setCalendarPopOver} setGenrePopoverOpen={setGenrePopoverOpen}
          setLocPopoverOpen={setLocPopoverOpen} defaultTimeFrame={props.settings.defaultTimeframeForSearch} psBarSettings={props.settings.powersearchBarOpts}
          searchEraseAndSubmit={searchEraseAndSubmit} components={props.settings.components}
        />    
        <div className="hearby-powersearch-area hearby-submit-search" onClick={handleClick}><button className="hearby-submit-button"><FontAwesomeIcon className="hearby-submit-button-icon" icon={faSearch}/></button></div>
        </div>
    );
  }


};